/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  GuardrailsPolicy,
  GuardrailsPolicy$inboundSchema,
  GuardrailsPolicy$Outbound,
  GuardrailsPolicy$outboundSchema,
} from "./guardrailspolicy.js";

export type ListGuardrailsPoliciesResponse = {
  object: "list";
  data: Array<GuardrailsPolicy>;
};

/** @internal */
export const ListGuardrailsPoliciesResponse$inboundSchema: z.ZodType<
  ListGuardrailsPoliciesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(GuardrailsPolicy$inboundSchema),
});
/** @internal */
export type ListGuardrailsPoliciesResponse$Outbound = {
  object: "list";
  data: Array<GuardrailsPolicy$Outbound>;
};

/** @internal */
export const ListGuardrailsPoliciesResponse$outboundSchema: z.ZodType<
  ListGuardrailsPoliciesResponse$Outbound,
  z.ZodTypeDef,
  ListGuardrailsPoliciesResponse
> = z.object({
  object: z.literal("list"),
  data: z.array(GuardrailsPolicy$outboundSchema),
});

export function listGuardrailsPoliciesResponseToJSON(
  listGuardrailsPoliciesResponse: ListGuardrailsPoliciesResponse,
): string {
  return JSON.stringify(
    ListGuardrailsPoliciesResponse$outboundSchema.parse(
      listGuardrailsPoliciesResponse,
    ),
  );
}
export function listGuardrailsPoliciesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListGuardrailsPoliciesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListGuardrailsPoliciesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListGuardrailsPoliciesResponse' from JSON`,
  );
}
